import React from "react"
import { useMatch } from "react-router-dom"
import { BreadCrumbs } from "ui/BreadCrumbs"

export const ResourcesBreadcrumb = () => {
  // Check if we're on equipment details page
  const matchDetail = useMatch("/pro/home/resources/equipment/:id")
  const isDetail = !!matchDetail

  const subPages = isDetail ? ["Resource details"] : []

  return <BreadCrumbs iconName="boat" category="Resources" subPages={subPages} />
}
